/* eslint-disable no-undef */
// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import 'core-js/es6/promise';
import 'core-js/es6/string';
import 'core-js/es7/array';
import Vue from 'vue';
import VueDraggableResizable from 'vue-draggable-resizable'

// optionally import default styles
import 'vue-draggable-resizable/dist/VueDraggableResizable.css'
import BootstrapVue from 'bootstrap-vue';
import App from './App';
import router from './router';
import { store } from './store/store';
import 'animate.css';
import 'material-icons/iconfont/material-icons.css';

import FirebaseApi from './moduleApi/FirebaseApi';
import { blockUi, unblockUi } from './shared/utils';


Vue.component('vue-draggable-resizable', VueDraggableResizable)
import Vuetify from 'vuetify';
Vue.use(Vuetify);

import CKEditor from "ckeditor4-vue";
Vue.use(CKEditor);

Vue.use(BootstrapVue);
Vue.config.silent =
  window.MyConfig.environment == "production" && window.MyConfig.environment;
Vue.config.productionTip =
  window.MyConfig.environment != "production" && window.MyConfig.environment;
Vue.config.devtools =
  window.MyConfig.environment != "production" && window.MyConfig.environment;
// Vue.config.silent = true;
// Vue.config.productionTip = true;
// import library

window.jQuery = window.$ = require("jquery");
window.toastr = require("toastr");
window.hash = require("object-hash");
window.toastr.options = {
  allowHtml: true,
  closeButton: true,
  debug: false,
  newestOnTop: false,
  progressBar: true,
  positionClass: "toast-top-right",
  preventDuplicates: true,
  onclick: null,
  showDuration: "300",
  hideDuration: "1000",
  timeOut: "3500",
  extendedTimeOut: "4000",
  showEasing: "swing",
  hideEasing: "linear",
  showMethod: "fadeIn",
  hideMethod: "fadeOut",
};
window.Ladda = require("ladda");

import Element from "element-ui";
import locale from "element-ui/lib/locale";
import enLocale from "element-ui/lib/locale/lang/en";
import viLocale from "element-ui/lib/locale/lang/vi";
enLocale.el.datepicker.year = "";
viLocale.el.datepicker.year = "";

if (window.MyConfig.language == "vi") {
  locale.use(viLocale);
}
if (window.MyConfig.language == "en") {
  locale.use(enLocale);
}

Vue.use(Element, {
  size: "small",
  zIndex: 3000,
});

// import Service

import mushroom from "pmcc-api";
mushroom.$using(window.MyConfig.hostApi);

mushroom._on("beforeSend", function (arg) {
  arg.headers = arg.headers || {};
  arg.headers["X-Client"] = "WebChamCong";
  arg.headers["X-Client-Platform"] = "Mushroom";
  arg.headers["X-Client-Version"] = "1.0";
});
function checkProEnvironment() {
  // Mở Cmt code nếu muốn log trên môi trường test
  // if (window.MyConfig.environment == "production") {
  //   return false //Sẽ không log trên môi trường production
  // } else {
  //   return true //Sẽ log trên môi trường test
  // }
  return false;
}
mushroom.$setting.set("diagnostic.log_request", checkProEnvironment());
mushroom.$setting.set("diagnostic.log_response", checkProEnvironment());
mushroom.$setting.set(
  "diagnostic.warning_slow_connection",
  checkProEnvironment()
);

// import directive
import ladda from "./directive/ladda";
Vue.directive("ladda", ladda);

import filters from "./directive/filters";
Vue.filter("capitalize", filters.capitalize);

// Create Directive for Notification component
Vue.directive("click-outside", {
  bind(el, binding, vnode) {
    // console.log(el);
    // console.log(binding);
    // console.log(vnode);
    var vm = vnode.context;
    var callback = binding.value;

    el.clickOutsideEvent = function(event) {
      if (!(el == event.target || el.contains(event.target))) {
        return callback.call(vm, event);
      }
    };
    document.body.addEventListener("click", el.clickOutsideEvent);
  },
  unbind(el) {
    // console.log('unbind...');
    document.body.removeEventListener("click", el.clickOutsideEvent);
  }
});

import ElementUIMoney from "./service/ElementUIMoney";
import VCalendar from "./plugins/v-calendar";

import AuthService from "./service/AuthService";
import SharedAuthService from "./service/SharedAuthService";
import EventBus from "./service/EventBus";
let haveLogout = false;

SharedAuthService.hydrateLocalTokenFromSharedCookie();
SharedAuthService.syncCurrentLocalTokenToCookie();

function updateOnlineStatus() {
  let _this = this;
  var condition = navigator.onLine ? "online" : "offline";
  if (condition == "offline") {
    _this.$notify({
      message: "I'm at the bottom left corner",
      position: "bottom-right",
      type: "warning",
    });
  }
  if (condition == "online") window.toastr.success("Kết nối mạng bình thường");
}

// window.addEventListener('online',  updateOnlineStatus)
// window.addEventListener('offline', updateOnlineStatus)

function reloadStatus() {
  let pathLocationLogin =
    location.protocol + "//" + location.host + "/auth/login";
  let pathLocationLoginGov =
    location.protocol + "//" + location.host + "/auth/gov-login";
  if (
    pathLocationLogin == window.location.href ||
    pathLocationLoginGov == window.location.href
  ) {
    return;
  }
  if (checkValidToken() === false) {
    return;
  }
  setTimeout(() => {
    reloadStatus();
  }, 1000 * 5); //Sau 5s lại chạy lại 1 lần
}
reloadStatus();

function checkValidToken() {
  let check = true;
  SharedAuthService.hydrateLocalTokenFromSharedCookie();
  let getToken = SharedAuthService.getLocalToken();
  if (getToken != undefined) {
    AuthService.status()
      .then((res) => {
        if (res.status && res.status == "guest") {
          if (haveLogout === false) {
            window.toastr.warning(
              "Tài khoản của bạn đã đăng nhập ở thiết bị khác!"
            );
          }
          setTimeout(() => {
            check = false;
            window.location.href = "/auth/login";
          }, 2000);
        }
      })
      .catch((e) => {
        console.log("error status", e);
      });
  }
  return check;
}
EventBus.$off("logout");
EventBus.$on("logout", () => {
  haveLogout = true;
});
EventBus.$off("loadStatus");
EventBus.$on("loadStatus", () => {
  setTimeout(() => {
    reloadStatus();
  }, 4000);
});
mushroom._on("$auth.loggedout", (info) => {
  if (info && info.source == "fromOtherTab") {
    // người dùng đã log out ở tab khác
    window.toastr.warning("Tài khoản của bạn đã đăng xuất!");
    // thực hiện chuyển sang trang login
    setTimeout(() => {
      window.location.href = "/auth/login";
    }, 2000);
  }
});

mushroom._on("$auth.loggedin", (token, rootUrl, info) => {
  if (info && info.source == "fromOtherTab") {
    // người dùng đã log in ở tab khác
    // thực hiện chuyển sang trang chủ
    this.$router.push({ name: "Admin-Hello" }).catch((err) => { });
  }
});

//------------------------------------Start Firebase -------------------------------------------------------------------------------------------------
import firebase from 'firebase/compat';
import 'firebase/compat/auth';
import 'firebase/compat/firestore';
import { getMessaging, getToken, onMessage, isSupported } from "firebase/messaging";

// Khởi tạo Firebase TRƯỚC khi gọi getMessaging
firebase.initializeApp(window.MyConfig.firebase);

let messaging = null;

if (!firebase.apps.length) {
  firebase.initializeApp(window.MyConfig.firebase);
}

async function saveFirebaseToken() {
  if (!messaging) return;
  if (typeof Notification !== "undefined" && Notification.permission !== "granted") {
    return;
  }

  try {
    const currentToken = await getToken(messaging, {
      vapidKey: window.MyConfig.firebaseVapidkey
    });

    if (!currentToken) {
      console.warn("No token available, request permission.");
      window.toastr.warning("Vui lòng cho phép thông báo để nhận cảnh báo.");
      unblockUi();
      return;
    }

    const savedFirebaseToken = window.localStorage.getItem("currentToken");
    if (savedFirebaseToken !== currentToken) {
      window.localStorage.setItem("currentToken", currentToken);
      const dataPost = getDeviceDetail(currentToken);
      await FirebaseApi.create(dataPost);
    }
  } catch (err) {
    if (
      err &&
      (err.code === "messaging/token-subscribe-failed" ||
        /missing required authentication credential/i.test(err.message || ""))
    ) {
      console.warn(
        "Firebase messaging subscription failed. Check Firebase Web Push configuration.",
        err
      );
    } else {
      console.error("Error getting token:", err);
    }
    unblockUi();
  }
}

if (typeof window !== 'undefined' && typeof navigator !== 'undefined') {
  isSupported().then((supported) => {
    if (supported) {
      messaging = getMessaging();
      setupMessaging(messaging);
    } else {
      console.warn("Firebase Messaging not supported in this browser.");
    }
  });
}

function setupMessaging(messaging) {
  EventBus.$off("saveFirebaseToken");
  EventBus.$on("saveFirebaseToken", () => {
    saveFirebaseToken();
  });

  onMessage(messaging, (payload) => {
    EventBus.$emit("receivedOnMessage", payload);
  });
}

// Vue.prototype.$messaging = firebaseMessaging;
//---------------------------------------------------------------------End of Firebase--------------------------------------------------------------------

function getDeviceDetail(token) {
  let nVer = navigator.appVersion;
  let nAgt = navigator.userAgent;
  let browserName = navigator.appName;
  let fullVersion = "" + parseFloat(navigator.appVersion);
  let majorVersion = parseInt(navigator.appVersion, 10);
  let nameOffset, verOffset, ix;
  let OSName="Unknown OS";

  // In Opera, the true version is after "OPR" or after "Version"
  if ((verOffset = nAgt.indexOf("OPR")) != -1) {
    browserName = "Opera";
    fullVersion = nAgt.substring(verOffset + 4);
    if ((verOffset = nAgt.indexOf("Version")) != -1)
      fullVersion = nAgt.substring(verOffset + 8);
  }
  // In MS Edge, the true version is after "Edg" in userAgent
  else if ((verOffset = nAgt.indexOf("Edg")) != -1) {
    browserName = "Microsoft Edge";
    fullVersion = nAgt.substring(verOffset + 4);
  }
  // In MSIE, the true version is after "MSIE" in userAgent
  else if ((verOffset = nAgt.indexOf("MSIE")) != -1) {
    browserName = "Microsoft Internet Explorer";
    fullVersion = nAgt.substring(verOffset + 5);
  }
  // In Chrome, the true version is after "Chrome"
  else if ((verOffset = nAgt.indexOf("Chrome")) != -1) {
    browserName = "Chrome";
    fullVersion = nAgt.substring(verOffset + 7);
  }
  // In Safari, the true version is after "Safari" or after "Version"
  else if ((verOffset = nAgt.indexOf("Safari")) != -1) {
    browserName = "Safari";
    fullVersion = nAgt.substring(verOffset + 7);
    if ((verOffset = nAgt.indexOf("Version")) != -1)
      fullVersion = nAgt.substring(verOffset + 8);
  }
  // In Firefox, the true version is after "Firefox"
  else if ((verOffset = nAgt.indexOf("Firefox")) != -1) {
    browserName = "Firefox";
    fullVersion = nAgt.substring(verOffset + 8);
  }
  // In most other browsers, "name/version" is at the end of userAgent
  else if (
    (nameOffset = nAgt.lastIndexOf(" ") + 1) <
    (verOffset = nAgt.lastIndexOf("/"))
  ) {
    browserName = nAgt.substring(nameOffset, verOffset);
    fullVersion = nAgt.substring(verOffset + 1);
    if (browserName.toLowerCase() == browserName.toUpperCase()) {
      browserName = navigator.appName;
    }
  }
  // trim the fullVersion string at semicolon/space if present
  if ((ix = fullVersion.indexOf(";")) != -1)
    fullVersion = fullVersion.substring(0, ix);
  if ((ix = fullVersion.indexOf(" ")) != -1)
    fullVersion = fullVersion.substring(0, ix);

  majorVersion = parseInt("" + fullVersion, 10);
  if (isNaN(majorVersion)) {
    fullVersion = "" + parseFloat(navigator.appVersion);
    majorVersion = parseInt(navigator.appVersion, 10);
  }

  if (navigator.appVersion.indexOf("Win")!=-1) OSName="Windows";
  if (navigator.appVersion.indexOf("Mac")!=-1) OSName="MacOS";
  if (navigator.appVersion.indexOf("X11")!=-1) OSName="UNIX";
  if (navigator.appVersion.indexOf("Linux")!=-1) OSName="Linux";

  const data = {
    token: token, // required - Firebase token
    device: {
      os: 'web', // optional, enum(iOS, iPadOS, Android, web) - Hệ điều hành
      pv: fullVersion, // optional - Phiên bản hệ điều hành
      d: nAgt, // optional - Mã thiết bị
      uid: OSName, // optional - Uid thiết bị
    }, // required - Thông tin thiết bị
    app: {
      wv: new Date().getTime(), // optional - Web version
    } // required - Thông tin ứng dụng
  }
  return data;
}

/* eslint-disable no-new */
window.vm = new Vue({
  el: "#app",
  router,
  ElementUIMoney,
  VCalendar,
  vuetify: new Vuetify(),
  template: "<App/>",
  store,
  data: function () {
    return {};
  },
  components: {
    App,
  },
  methods: {},
  created: function () { 
    if (window.MyConfig.environment !== "development") {
    Notification.requestPermission().then((permission) => {
    if (permission === "granted") {
      EventBus.$emit("saveFirebaseToken");
    } else {
      console.log("Notification permission denied");
    }
  });
}
  },
});
